module.exports = __webpack_public_path__ + "img/loader.9c7326d2.gif";